import type { CSSProperties, ReactNode } from "react";
import { T } from "../tokens";

export interface HanProps {
  children: ReactNode;
  size?: number;
  weight?: number;
  color?: string;
  ls?: string;
  lh?: number;
  style?: CSSProperties;
}

export function Han({
  children,
  size = 18,
  weight = 300,
  color = T.ink900,
  ls = "0.02em",
  lh = 1.8,
  style,
}: HanProps) {
  return (
    <span
      style={{
        fontFamily: T.han,
        fontWeight: weight,
        // 2026-05-30 可讀性下限:閱讀內文不小於 12px(老年人 / 強光下)。
        // 裝飾性小字(tab 英文等)直接寫 inline fontSize、不走 Han、不受影響。
        fontSize: Math.max(size, 12),
        lineHeight: lh,
        letterSpacing: ls,
        color,
        ...style,
      }}
    >
      {children}
    </span>
  );
}
